/* eslint-disable no-console */
import React, { createContext, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Classifier } from '../../generated/model/models';
import {
  Classifiers,
  ClassifiersProviderProps,
  ClassifiersTypes,
} from './ClassifiersContext.types';

const ClassifiersContext = createContext<Classifiers | undefined>(undefined);
const initialClassifiersState: Classifiers = {
  legalForm: [],
  status: [],
  ownershipType: [],
  relationType: [],
  currency: [],
  accountingStandard: [],
  accountingStandardType: [],
  accountConsolidation: [],
  dbVersions: [],
  regionAndCountry: [],
  regionAndCountryFull: [],
  nace: [],
  sic: [],
  profitAndLoss: [],
  balanceData: [],
  companyReportFields: [],
  contactInfoAvailability: [],
  dataset: [],
  staticCurrency: [],
};

export const ClassifiersContextProvider = ({ children, classifiers }: ClassifiersProviderProps) => {
  const state = useMemo(
    () => ({
      ...initialClassifiersState,
      ...classifiers,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <ClassifiersContext.Provider value={state}>{children}</ClassifiersContext.Provider>;
};

export const useClassifiersState = () => {
  const context = useContext(ClassifiersContext);
  const { t } = useTranslation();

  if (context === undefined) {
    throw new Error(
      t('app:error.contextWithin', {
        action: 'ClassifiersState',
        provider: 'ClassifiersProvider',
      }),
    );
  }

  return context;
};
export function useClassifierState(classifier: ClassifiersTypes): Classifier[] {
  const state = useClassifiersState();

  return classifier && state[classifier] ? state[classifier] : [];
}
